export default function AmbuSeva_Privacy_Policy() {
    return (
        <>
            <meta charSet="utf-8" />
            <p>Privacy Policy</p>
            <p>
                Matri Mission 'O' Mandir Seva Trust - Privacy Policy (AmbuSeva Patient App,
                Driver App and Partner App)
            </p>
            <p>Last Updated: 27nd Jan 2026</p>
            <br />
            <h3>INTRODUCTION &amp; SCOPE</h3>
            <p>
                This Privacy Policy explains how Matri Mission 'O' Mandir Seva Trust ("we",
                "us", "our") collects, uses, stores, discloses and otherwise processes
                personal data in connection with the AmbuSeva Patient App, Driver App and
                Partner App (collectively, the "Apps") and related services (the "Services"). 
                This Policy applies to all users including patients, drivers,
                ambulance partners, and third-party visitors interacting with the Apps.
            </p>
            <br />
            <h3>1. KEY DEFINITIONS</h3>
            <p>
                1.1 "Personal Data" means any information that relates to an identified or
                identifiable natural person.
            </p>
            <p>
                1.2 "Sensitive Personal Data" or "Special Category Data" includes
                health-related information and other sensitive categories as defined under
                applicable data protection laws.
            </p>
            <p>
                1.3 "Controller" means the entity that determines the purposes and means of
                processing Personal Data. For the purposes of these Apps, Matri Mission 'O'
                Mandir Seva Trust acts as Controller. Specific partner-held data may be
                processed by Partner acting as Controller in relation to their services.
            </p>
            <br />
            <h3>2. CATEGORIES OF DATA COLLECTED</h3>
            <p>
                We collect the following categories of Personal Data depending on the
                Service used and legal basis for processing:
            </p>
            <p>
                2.1 Identity Data: Name, identity numbers and photographs where voluntarily
                provided.
            </p>
            <p>2.2 Contact Data: mobile number, email address and/or postal address.</p>
            <p>
                2.3 Location Data: Real-Time GPS location, pickup and drop-off locations,
                trip route and trip history.</p>
            <p>
                2.4 Ambulance Data: Whether User requested ICU or normal ambulance services.
            </p>
            <p>
                2.5 Payment &amp; Financial Data: transaction history, payment instrument
                metadata, invoicing details, refunds and settlement records.
            </p>
            <p>
                2.6 Technical &amp; Usage Data: we may collect device identifiers, operating
                system, IP address, app logs, crash reports and app analytics data.
            </p>
            <p>
                2.7 Compliance &amp; Administrative Data: Ambulance and Driver documents,
                licenses, permits, background check results and/or for Drivers/Partners.
            </p>
            <br />
            <h3>
                3. PURPOSES OF PROCESSING &amp; LAWFUL BASIS We process Personal Data for
                the following purposes: </h3>
            <p>
                3.1 Service Provision: to enable dispatch,
                navigation, trip management, communication, and billing.
            </p>
            <p>
                3.2 Safety &amp; Security: to verify identity, investigate incidents and
                ensure safety of patients and staff.
            </p>
            <p>
                3.3 Legal &amp; Regulatory Compliance:
                to respond to lawful requests from government, courts, regulatory
                authorities, and to comply with healthcare, transport and taxation
                obligations.
            </p>
            <p>
                3.4 Research &amp; Service Improvement: to analyze usage patterns, improve
                features, undertake anonymized research and quality assurance.
            </p>
            <p>
                3.5 Marketing &amp; Communications: to send operational notices and relevant
                service updates.
            </p>
            <br />
            <h3>4. THIRD-PARTY SHARING &amp; DISCLOSURES</h3>
            <p>We may share Personal Data with:</p>
            <p>
                4.1 Ambulance Providers and Drivers: limited personal information, contact
                information and trip related data necessary for provision of the service.
            </p>
            <p>
                4.2 Payment Service Providers and Financial Institutions: for processing
                payments and settlements.
            </p>
            <p>
                4.3 Cloud &amp; Infrastructure Providers: for
                hosting, storage and service provisioning under strict contractual
                safeguards.
            </p>
            <p>
                4.4 Government, Courts &amp; Law Enforcement: to comply with legal
                obligations or in response to lawful orders.
            </p>
            <br />
            <h3>5. DATA TRANSFERS, STORAGE &amp; RETENTION</h3>
            <p>
                5.1 Storage Location: Personal Data are stored on Amazon AWS servers located
                in Hyderabad, India.
            </p>
            <p>
                5.2 Retention Periods: We retain Personal Data only as long as necessary to
                fulfill the purposes described, for legal compliance, dispute resolution,
                tax obligations, or as required by law.
            </p>
            <p>
                5.3 Backup &amp; Archival: Backups are retained for disaster recovery and
                may result in residual storage of Personal Data for longer periods in
                archival systems.
            </p>
            <br />
            <h3>6. SECURITY MEASURES</h3>
            <p>
                6.1 Technical Controls: we have encryption in transit (TLS) and encryption
                at rest where possible for data transfer. We follow secure coding practices.
            </p>
            <p>
                6.2 Organizational Controls: Limited access is provided to limited user data
                on a need-to-know basis for incident response and support.
            </p>
            <p>
                6.3 Breach Notification: In the event of a data breach that creates a risk
                to the rights and freedoms of individuals, we will try to notify affected
                individuals and relevant authorities in accordance with applicable law and
                as soon as reasonably practicable.
            </p>
            <br />
            <h3>7. DATA SUBJECT RIGHTS &amp; HOW TO EXERCISE THEM</h3>
            <p>
                7.1 Rights: Subject to applicable law, users may have the right to: view,
                correct, update, and request to DELETE their data by using DELETE Data Feature on app.
            </p>
            <p>
                7.2 Limitations: Certain DATA related to past journeys history will be retained and will not be deleted
                due to operational reasons.
            </p>
            <br />
            <h3>8. ANALYTICS</h3>
            <p>
                8.1 Analytics: Third-party analytics providers may collect aggregated or
                pseudonymized data to assist in improving the Apps.
            </p>
            <br />
            <h3>9. CHILDREN</h3>
            <p>
                9.1 Children: The Apps are not intended for direct use by children below the
                age of majority. If a child requires an ambulance, a parent or legal
                guardian should make arrangements. We do not knowingly collect data from
                minors without parental consent.
            </p>
            <br />
            <h3>10. AUTOMATED DECISION-MAKING</h3>
            <p>
                10.1 Automated Processing: We may use automated systems to match Users to
                Ambulance Providers, prioritise dispatch. These systems use objective
                criteria such as location and ambulance/driver availability.
            </p>
            <p>
                10.2 Human Oversight: Critical decisions affecting users rights will have
                appropriate human oversight. Users may request explanation and review in
                accordance with applicable law.
            </p>
            <br />
            <h3>11. DATA PROTECTION BY DESIGN</h3>
            <p>
                11.1 We implement reasonable privacy-by-design practices during product
                development and adopt data minimization and access limitation where
                feasible.
            </p>
            <br />
            <h3>12. DATA BREACH RESPONSE &amp; NOTIFICATION</h3>
            <p>
                12.1 Incident Response: We maintain an incident response plan to
                investigate, contain and remediate data incidents.
            </p>
            <p>
                12.2 Notification: Affected users and regulators will be notified in
                accordance with applicable legislation and to the extent required by law.
            </p>
            <br />
            <h3>13. CHANGES TO THIS POLICY</h3>
            <p>
                13.1 Updates: We may modify this Privacy Policy. Material changes will be
                communicated via the Apps or other means. Continued use after notification
                constitutes acceptance.
            </p>
            <br />
            <h3>14. GOVERNING LAW &amp; CONTACT</h3>
            <p>
                14.1 Governing Law: This Policy and related data practices are governed by
                the laws of India.
            </p>
            <p>
                14.2 Disputes shall be subject to the exclusive jurisdiction of the courts
                located in Kalyani, India.
            </p>
            <br />
            <h3>15. CONTACT INFORMATION</h3>
            <p>Matri Mission 'O' Mandir Seva Trust</p>
            <p>Address: A-9/155, Kalyani, Nadia, West Bengal, India, 741235.</p>
            <p>Email: info@mail.matrimission.org</p>
            <p>Phone: +91 70594 28773</p>
            <p>Website: <a href="https://www.matrimission.org">www.matrimission.org</a></p>
        </>
    );
}
